import { SelectOption } from "flicket-ui";
import range from "lodash/range";

export const getQuantityOptions = (
  min: number,
  max: number
): SelectOption[] => {
  const result: SelectOption[] = [];

  min = min ? min : 1;
  max = max ? max : 40;

  if (min > 0) {
    result.push({
      label: "-",
      value: "0",
    });
  }

  range(min, max + 1).forEach((i) => {
    result.push({
      label: String(i),
      value: String(i),
    });
  });

  return result;
};
